<script>
import isNull from 'lodash/isNull'
import { feedbackComputed } from '@state/helpers/feedback'

export default {
  props: {
    showResetButton: {
      type: Boolean,
    },
  },
  data() {
    return {
      inValidFileUpload: null,
      uploadFileFeedBack: '',
      placeholder: this.$t('common.upload_image'),
    }
  },
  computed: {
    ...feedbackComputed,
    isValidate() {
      if (isNull(this.inValidFileUpload)) {
        return ''
      }
      return 'is-valid'
    },
  },
  methods: {
    handleUploadFile(files, event) {
      this.uploadFileFeedBack = ''
      this.inValidFileUpload = null
      this.$emit('upload:reset')
      if (!files[0]) {
        return
      }
      const reader = new FileReader()
      reader.readAsDataURL(files[0])
      const self = this
      const fileName = files[0].name
      const ext = /\.(?:(jpg)|(png)|(gif))$/g
      if (!fileName?.toLowerCase().match(ext)) {
        this.uploadFileFeedBack =
          'JPG/GIF/PNG形式のファイルを選択してください。'
        this.inValidFileUpload = false
        event.target.value = '' // clear file
      } else if (files[0].size > 1048576) {
        this.uploadFileFeedBack = '1MB以下のファイルを選択してください。'
        this.inValidFileUpload = false
        event.target.value = '' // clear file
      } else {
        reader.onloadend = function() {
          const imgObj = new Image()
          self.placeholder = files[0].name
          const imgBase = reader.result.split(',')[1]
          self.$emit('upload:change', imgBase, files[0].name)
          event.target.value = ''
          imgObj.src = reader.result
          self.uploadFileFeedBack = ''
          self.inValidFileUpload = null
        }
      }
    },
    resetFile() {
      this.$emit('upload:reset')
      this.placeholder = this.$t('common.upload_image')
    },
  },
}
</script>

<template>
  <div class="d-flex align-items-start">
    <CInputFile
      v-bind="$attrs"
      :class="['flex-1 w-auto', !inValidFileUpload ? 'mb-4' : 'mb-3']"
      custom
      :[isValidate]="inValidFileUpload"
      :invalid-feedback="uploadFileFeedBack"
      add-label-classes="text-truncate"
      :placeholder="placeholder"
      accept="image/*"
      @change="handleUploadFile"
    />
    <CButton
      v-if="showResetButton"
      color="dark"
      variant="outline"
      class="py-0 ml-2 mt-2"
      @click="resetFile"
    >
      クリア</CButton
    >
  </div>
</template>
